export enum IconId {
  ArrowDownRight = 'arrow-down-right',
  ArrowUpRight = 'arrow-up-right',
  Briefcase = 'briefcase',
  Burger = 'burger',
  Calendar = 'calendar',
  CircularArrow = 'circular-arrow',
  Cross = 'cross',
  Download = 'download',
  Folder = 'folder',
  Home = 'home',
  Logout = 'log-out',
  Star = 'star',
  Target = 'target',
  ThumbsDown = 'thumbs-down',

  RadioTrue = 'radio-true',
  RadioFalse = 'radio-false',

  IllustrationBattery = 'illustration-battery',
  IllustrationEcoBuilding = 'illustration-eco-building',
  IllustrationEcoHeart = 'illustration-eco-heart-co2-emitted',
  IllustrationEcoLightbulb = 'illustration-eco-lightbulb',
  IllustrationFactory = 'illustration-factory',
  IllustrationLeaves = 'illustration-sprouting-leaves',
  IllustrationPotPlant = 'illustration-pot-plant',
  IllustrationRecyclingBin = 'illustration-recycling-bin',
  IllustrationShield = 'illustration-shield',
  IllustrationSkyscrapers = 'illustration-skyscrapers',
  IllustrationTapWater = 'illustration-tap-water',
  IllustrationTrees = 'illustration-trees',
}
